export default __webpack_public_path__ + "static/end_1-991d9ab37738964628b5d15234cd20af.png";